import { Component, OnInit } from '@angular/core';
import {ConfigService} from "../../../services/config.service";

@Component({
    selector: 'app-footer-verificateur',
    templateUrl: './footer-verificateur.component.html',
    styleUrls: ['./footer-verificateur.component.css'],
    standalone: false
})
export class FooterVerificateurComponent implements OnInit {

  constructor(private configService: ConfigService) { }
  public entityType = this.configService.entityType;

  ngOnInit() {
  }

}
